import React from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../../components/layout/Navbar";
import Footer from "../../components/layout/Footer";
import "../../components/styles/parentalDetailPage.scss";

/**
 * ParentalDetailPage — Parental control detail for a kid's account
 * Figma: Parental control detail (from T2 design system)
 *
 * Layout:
 *   - Navbar
 *   - Breadcrumb: "Parental control > Selly's account" (first gray, last bold white)
 *   - Card: "Parental control" heading
 *     - 2 clickable rows (Content rating, View activity)
 *     - Each row: title + description + chevron right icon
 *     - Border-bottom between rows
 *   - Footer
 */

const ParentalDetailPage = () => {
  const navigate = useNavigate();

  const rows = [
    {
      id: 1,
      title: "Content rating",
      description:
        "Subtitle display settings such as text color, text size, and text background",
      action: () => navigate("/settings/content-rating"),
    },
    {
      id: 2,
      title: "View activity",
      description:
        "Subtitle display settings such as text color, text size, and text background",
      action: () => navigate("/settings/view-activity"),
    },
  ];

  return (
    <div className="parental-detail-page">
      <Navbar activeTab="" />

      <div className="parental-detail-page__body">
        {/* Breadcrumb */}
        <div className="parental-detail-page__breadcrumb">
          <span className="parental-detail-page__breadcrumb-item">
            Parental control
          </span>
          <span className="parental-detail-page__breadcrumb-separator">
            &gt;
          </span>
          <span className="parental-detail-page__breadcrumb-item parental-detail-page__breadcrumb-item--active">
            Selly's account
          </span>
        </div>

        {/* Card */}
        <div className="parental-detail-page__card">
          <h2 className="parental-detail-page__card-title">Parental control</h2>

          {/* Rows */}
          {rows.map((row, index) => (
            <button
              key={row.id}
              className={`parental-detail-page__row ${
                index < rows.length - 1 ? "parental-detail-page__row--divider" : ""
              }`}
              onClick={row.action}
            >
              <div className="parental-detail-page__row-content">
                <h3 className="parental-detail-page__row-title">
                  {row.title}
                </h3>
                <p className="parental-detail-page__row-description">
                  {row.description}
                </p>
              </div>
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                className="parental-detail-page__row-icon"
              >
                <path
                  d="M9 18L15 12L9 6"
                  stroke="#737373"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </button>
          ))}
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default ParentalDetailPage;
